'use client';

import { ReactNode } from 'react';
import classnames from 'classnames';

const className = classnames(
  'cursor-pointer',
  'text-pill-color',
  'px-2 py-1',
  'rounded-md',
  'bg-pill-background-color'
);

interface Props {
  children: ReactNode;
}

const TextSelect = ({ children }: Props) => (
  <span className={className}>{children}</span>
);

export default TextSelect;
